[
  {
    "id": "chapter:5a",
    "q": "Before you start the vehicle:",
    "answer": {
      "text": "Make sure the parking brake is set",
      "section": 5,
      "topic": "Starting",
      "page": 30
    },
    "otherChoices": ["Turn the low beam headlights on", "Place your foot on the accelerator"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:5b",
    "q": "Where should your hands be placed on the steering wheel when using hand-to-hand steering?",
    "answer": {
      "text": "Left hand between 7 and 8 o’clock and right hand between 4 and 5 o’clock",
      "section": 5,
      "topic": "Types of Steering Methods",
      "page": 31
    },
    "otherChoices": [
      "Left hand between 9 and 10 o’clock and right hand between 2 and 3 o’clock",
      "Left hand between 10 and 11 o’clock and right hand between 1 and 2 o’clock"
    ],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:5c",
    "q": "Before stopping your vehicle on the roadway:",
    "answer": {
      "text": "Check mirrors for traffic",
      "section": 5,
      "topic": "Stopping",
      "page": 30
    },
    "otherChoices": ["Place your foot on the accelerator", "Set the parking brake"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "authored:s5-drive-wheels-spin",
    "q": "If the drive wheels begin to spin:",
    "answer": {
      "text": "Take your foot off the accelerator",
      "section": 5,
      "topic": "Accelerating",
      "page": 30
    },
    "otherChoices": ["Press down harder on the accelerator", "Move your foot to the brake and press firmly"],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s5-hand-over-hand-steering",
    "q": "Use hand-over-hand steering when:",
    "answer": {
      "text": "Turning the wheel at low speeds, such as at an intersection or when parking the vehicle",
      "section": 5,
      "topic": "Types of Steering Methods",
      "page": 31
    },
    "otherChoices": [
      "Turning the wheel during normal driving going forward above 10-15 mph",
      "Backing or operating vehicle controls that require a temporary reach from the steering wheel"
    ],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s5-backing-rear-window",
    "q": "When backing, your rearview and side mirrors:",
    "answer": {
      "text": "Do not show the area directly behind your vehicle",
      "section": 5,
      "topic": "Backing",
      "page": 32
    },
    "otherChoices": [
      "Remove the need to check behind the vehicle before you get in",
      "Let you face forward while the vehicle moves in reverse"
    ],
    "generated": null,
    "batch": "review-20260604",
    "version": 2,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s5-backing-check-before-entering",
    "q": "When backing, you must check behind your vehicle before you get in because:",
    "answer": {
      "text": "Children or small objects cannot be seen from the driver's seat",
      "section": 5,
      "topic": "Backing",
      "page": 32
    },
    "otherChoices": [
      "Your vehicle is much harder to steer while you are backing",
      "Passenger vehicle side view mirrors are not designed for backing the vehicle"
    ],
    "generated": null,
    "batch": "expansion-r1-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s5-backing-hand-position",
    "q": "When backing, grasp the steering wheel with your left hand:",
    "answer": {
      "text": "At 12 o'clock",
      "section": 5,
      "topic": "Backing",
      "page": 32
    },
    "otherChoices": ["Between 7 and 8 o'clock", "Between 8 and 9 o'clock"],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 2,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s5-one-hand-steering",
    "q": "Use one hand steering only when:",
    "answer": {
      "text": "Backing or operating vehicle controls that require a temporary reach from the steering wheel",
      "section": 5,
      "topic": "Types of Steering Methods",
      "page": 31
    },
    "otherChoices": [
      "Turning the wheel during normal driving activity going forward above 10-15 mph",
      "Turning the wheel at low speeds, such as at an intersection or when parking the vehicle"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s5-steering-direction",
    "q": "You always turn the steering wheel:",
    "answer": {
      "text": "In the direction you want the vehicle to move, whether moving forward or in reverse",
      "section": 5,
      "topic": "Steering",
      "page": 30
    },
    "otherChoices": [
      "In the opposite direction when moving in reverse",
      "No more than 180 degrees, in every situation"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 2,
    "updatedAt": "2026-08-04",
    "status": "verified"
  },
  {
    "id": "authored:s5-steering-input-amounts",
    "q": "When steering to move back on the road after an off-road encounter, or to evade a problem on the roadway:",
    "answer": {
      "text": "Moving back on the road takes only 45 to 90 degrees of steering, and evasive steering must be limited to not more than 180 degrees",
      "section": 5,
      "topic": "Types of Steering Methods, Evasive action steering",
      "page": 31
    },
    "otherChoices": [
      "Moving back on the road takes up to 180 degrees of steering, and evasive steering must be limited to not more than 45 to 90 degrees",
      "Both maneuvers take at least 180 degrees of steering input"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-03",
    "status": "verified"
  }
]
